import '../../modules/mode-components';

import * as angular from 'angular';

class ConsoleController {
  static $inject = ['$scope', '$element'];
  private lines: Array<any>;

  constructor(
    private $scope,
    private $element
  ) {
    $scope.lines = [];
  }

  $onInit() {
    this.lines = this.$scope.lines;
  }

  // currentLine is when clicked and content selected.
  // active is for hover state.
  select(selectedLine: any) {
    this.lines.forEach((line) => {
      line.active = false;
      line.currentLine = false;
      if (line !== selectedLine) {
        line.element.find('.btn').css({ visibility: 'hidden' });
      }
    });
    selectedLine.active = true;
    selectedLine.currentLine = true;
  }

  addLine(line: any) {
    this.lines.push(line);
    const index: number = this.lines.indexOf(line) + 1;
    let indexVal: string = index.toString();
    if (index < 10) {
      indexVal = '0' + index;
    }
    line.index = indexVal;
  }
}

const consoleComponent: angular.IComponentOptions = {
  transclude: true,
  template: `
<div class="console" ng-transclude></div>
`,
  controller: ConsoleController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('console', consoleComponent);
